import styled from 'styled-components'

export const Wrapper = styled.div`
  width: min(620px, 100%);
  padding: 18px;
  border: 1px solid #ece8e5;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.04);
`

export const Intro = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 14px;

  strong {
    color: #2f2f2f;
    font-size: 16px;
  }

  span {
    color: #787878;
    font-size: 12px;
    line-height: 1.45;
  }
`

export const SearchInput = styled.input`
  width: 100%;
  height: 42px;
  padding: 0 13px;
  border: 1px solid #dddddd;
  border-radius: 10px;
  outline: 0;
  font-size: 13px;

  &:focus {
    border-color: #d60000;
    box-shadow: 0 0 0 3px rgba(214, 0, 0, 0.06);
  }
`

export const Results = styled.div`
  margin-top: 8px;
  overflow: hidden;
  border: 1px solid #eeeeee;
  border-radius: 11px;
  background: #fff;
`

export const ResultButton = styled.button`
  width: 100%;
  min-height: 52px;
  display: grid;
  grid-template-columns: 34px 1fr auto;
  align-items: center;
  gap: 10px;
  padding: 7px 10px;
  border: 0;
  border-bottom: 1px solid #f1f1f1;
  background: #fff;
  text-align: left;
  cursor: pointer;

  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    background: #fff8f8;
  }

  span {
    color: #333;
    font-size: 13px;
  }

  b {
    color: #d60000;
    font-size: 11px;
  }
`

export const Avatar = styled.img`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
  background: #f2f2f2;
`

export const SelectedList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-top: 12px;
`

export const SelectedItem = styled.div`
  display: grid;
  grid-template-columns: 34px 1fr auto auto;
  align-items: center;
  gap: 9px;
  min-height: 50px;
  padding: 7px 9px;
  border-radius: 10px;
  background: #f8f8f7;

  span {
    color: #333;
    font-size: 13px;
    font-weight: 600;
  }

  small {
    color: #8a8a8a;
    font-size: 10px;
  }

  button {
    width: 26px;
    height: 26px;
    border: 0;
    border-radius: 50%;
    background: #fff;
    color: #c50000;
    cursor: pointer;
  }

  @media (max-width: 600px) {
    grid-template-columns: 34px 1fr auto;

    small {
      display: none;
    }
  }
`
